import { render, staticRenderFns } from "./DispatcherTasksTabRedirectToWorkArea.vue?vue&type=template&id=a692ad3a&"
import script from "./DispatcherTasksTabRedirectToWorkArea.vue?vue&type=script&lang=js&"
export * from "./DispatcherTasksTabRedirectToWorkArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QSelect,QItemSection,QItemLabel,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QSelect,QItemSection,QItemLabel,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn}, component.options.components || {})
